// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"5ae0c0c8c8b8026dbd58","303":"094241b8f9da7860f003","495":"f40023958ea9707c9270"}[chunkId] + ".js";
};